import { ReactElement } from 'react';
import { matchPath, NavLink, useLocation } from 'react-router-dom';
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { dashboardRoutesConfig } from 'modules/dashboard';
import { defiRoutesConfig } from 'modules/defi';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { useTranslation } from 'modules/i18n';

import { translation } from './translation';

interface INavigationProps {
  className?: string;
}

export function Navigation({ className }: INavigationProps): ReactElement {
  const { classes, cx } = useStyles();
  const { t, keys } = useTranslation(translation);
  const { onClose } = useDialog(KnownDialogs.navigation);

  const location = useLocation();

  const isStakePage = matchPath('/', location.pathname);

  return (
    <div className={cx(classes.root, className)}>
      <NavLink
        className={({ isActive }) =>
          cx(classes.item, (isStakePage || isActive) && classes.active)
        }
        to={dashboardRoutesConfig.staking.generatePath()}
        onClick={onClose}
      >
        {t(keys.staking)}
      </NavLink>

      <NavLink
        className={({ isActive }) =>
          cx(classes.item, isActive && classes.active)
        }
        to={defiRoutesConfig.defi.generatePath()}
        onClick={onClose}
      >
        {t(keys.defi)}
      </NavLink>
    </div>
  );
}

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3.5),
    zIndex: 1,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(10),
    },
  },
  item: {
    color: alpha(theme.palette.secondary.contrastText, 0.5),
    fontWeight: 500,
    fontSize: 14,
    textTransform: 'uppercase',
    padding: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  active: {
    color: theme.palette.primary.main,
  },
}));
